import { ChatLastMessageModel } from "api";
import notificationActionTypes from "constants/notification";
import { load } from "helpers/filtersStorage";
import { defaultConstants, defaultReducerBody, handleActions } from "helpers/reduxState";
import { Action } from "redux-actions";

const params = load("notifications_params", {});

const initialState: State = {
    key: "notifications",
    items: [],
    params: {
        start: 0,
        length: 30,
        filters: params.filters || [],
        queryFilter: params.queryFilter || {},
        customFilters: params.customFilters || {},
        preparedFilter: params.preparedFilter || {},
    },
    count: 0,
    isLoadingList: true,
    isLoadingCount: true,
    shouldUpdate: true,
};

const { READ_ALL_NOTIFICATIONS, READ_NOTIFICATION, TOGGLE_FAVORITE_NOTIFICATION } = notificationActionTypes;

type State = {
    key: "notifications";
    items: ChatLastMessageModel[];
    params: {
        start: number;
        length: number;
        filters: [];
        queryFilter: {};
        customFilters: {};
        preparedFilter: {};
    };
    count: number;
    isLoadingList: boolean | {};
    isLoadingCount: boolean | {};
    shouldUpdate: boolean;
};

type ReadNotificationPayload = { chatId: number };
type TogglePayload = { id: number; isFavorite: boolean };

type CombinedPayload = ReadNotificationPayload | TogglePayload;

export default handleActions<State, CombinedPayload>(
    {
        ...defaultReducerBody<ChatLastMessageModel, State>(defaultConstants("NOTIFICATIONS"), initialState),
        [READ_ALL_NOTIFICATIONS]: (state) => ({
            ...state,
            shouldUpdate: true,
            items: state.items.map((item) => ({ ...item, unreadMessagesCount: 0 })) as ChatLastMessageModel[],
        }),
        [READ_NOTIFICATION]: (state, { payload }: Action<ReadNotificationPayload>) => ({
            ...state,
            shouldUpdate: true,
            items: state.items.map((item) => ({
                ...item,
                ...(payload.chatId === item.chat?.id ? { unreadMessagesCount: 0 } : {}),
            })) as ChatLastMessageModel[],
        }),
        [TOGGLE_FAVORITE_NOTIFICATION]: (state, { payload }: Action<TogglePayload>) => ({
            ...state,
            items: state.items.map((item) =>
                item.id === payload.id ? { ...item, chat: { ...item.chat, isFavorite: payload.isFavorite } } : item,
            ) as ChatLastMessageModel[],
        }),
    },
    initialState,
);
